import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();
export const isDisabledRoute = (disabledRoutes, route) => disabledRoutes && disabledRoutes.includes(route);
export const isDisabledGtmRoute = (route) => {
    return isDisabledRoute(publicRuntimeConfig.gtm?.disabledRoutes, route);
};
export const isDisabledDatadogRoute = (route) => isDisabledRoute(publicRuntimeConfig.datadog?.disabledRoutes, route);
